import type { BuildMode, DeployTarget } from '@repo/shared-config/environment';

/**
 * Determines the cookie domain based on environment and deployment context.
 *
 * @param environment - The build mode (development, test, production, playwright)
 * @param deployTarget - The deployment target (staging, production)
 * @param locationHref - The current window location href
 * @returns The cookie domain or null for local development
 */
export function getSharedCookieDomain(
  environment: BuildMode,
  deployTarget: DeployTarget,
  locationHref: string
): string | null {
  const runningOnSubdomain = locationHref.includes('.dev.qonto.co');

  // Test and Playwright environments should not use shared cookie domains
  if (environment === 'test' || environment === 'playwright') {
    return null;
  }

  // Local development
  if (environment === 'development') {
    // Local development with subdomain sharing
    return runningOnSubdomain ? '.dev.qonto.co' : null;
  }

  // Deployed environments (production)
  return deployTarget === 'staging' ? '.qonto.co' : '.qonto.com';
}
